import React, {Fragment} from 'react'
import {Grid, Grow, Typography} from '@material-ui/core'
import {Field} from 'formik'

import MaskField from '../../../../components/MaskField'
import {StepHeader} from '../../styles'

const Step8 = () => {
  return (
    <Fragment>
      <Grow mountOnEnter in timeout={500}>
        <StepHeader>
          <Typography
            variant="body1"
            gutterBottom
            color="textPrimary">
            Passo 2 de 3
          </Typography>
          <Typography
            variant="h5"
            gutterBottom
            color="textPrimary">
            Dados da empresa
          </Typography>
        </StepHeader>
      </Grow>
      <Grow mountOnEnter in timeout={900}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Field
              name="phone"
              mask="(99) 99999-9999"
              label="Informe um número de celular com DDD?"
              helperText="Vamos enviar um código de confirmação para ele"
              fullWidth
              component={MaskField}
            />
          </Grid>
        </Grid>
      </Grow>
    </Fragment>
  );
};

export default Step8;
